import { useState } from 'react'
import { MinimalAlert, MinimalButton } from '@ovasabi/ui-minimal'
import { ChowModal } from '../../components/chow'
import * as S from '../ops/OpsStyle'
import { formatNaira, formatWhen } from '../ops/opsData'
import { campaignStatus, type Campaign } from './promotionModel'

interface Props { selected: Campaign; scope: string; now: number; busy: boolean; error: string; onClose: () => void; onToggle: () => void; onArchive: () => void }
export const CampaignDetail = ({ selected, scope, now, busy, error, onClose, onToggle, onArchive }: Props) => {
  const [confirming, setConfirming] = useState(false)
  const status = campaignStatus(selected, now)
  // Expired and fully redeemed campaigns can never apply again, so pausing is meaningless; removal is the only action.
  const ended = status === 'Expired' || status === 'Fully redeemed'
  return <ChowModal open title={selected.name} onClose={() => { if (!busy) onClose() }}>
    {error && <MinimalAlert tone="danger" title="Campaign not updated">{error}</MinimalAlert>}
    <S.Pill $tone={status === 'Active' ? 'ok' : 'flat'}>{status}</S.Pill>
    <S.CardTitle>{selected.code} · {selected.discount_bps / 100}% off</S.CardTitle>
    <p>{scope} · Funded by {selected.funded_by === 'chef' ? 'the chef' : 'ChooseChow'}</p>
    <p>Minimum food subtotal: {formatNaira(selected.min_subtotal_minor)}</p>
    <p>Discount cap: {selected.max_discount_minor ? formatNaira(selected.max_discount_minor) : 'No cap'}</p>
    <p>{formatWhen(selected.starts_at)} – {formatWhen(selected.ends_at)}</p>
    <p>{selected.redemption_count} checkouts reserved; limit: {selected.max_redemptions || 'unlimited'}.</p>
    <S.Note>Each checkout uses one redemption, even if the order goes unpaid or is cancelled. Orders already placed keep their price.</S.Note>
    {confirming ? <>
      <S.Note>Remove {selected.code}? It stops applying at checkout and leaves this list. Past orders keep their discount, and the code cannot be reused.</S.Note>
      <MinimalButton disabled={busy} onClick={() => onArchive()}>{busy ? 'Removing…' : 'Yes, remove campaign'}</MinimalButton>
      <MinimalButton variant="ghost" disabled={busy} onClick={() => setConfirming(false)}>Keep campaign</MinimalButton>
    </> : <>
      {!ended && <MinimalButton disabled={busy} onClick={() => onToggle()}>
        {busy ? 'Updating…' : selected.is_active ? 'Pause campaign' : 'Resume campaign'}
      </MinimalButton>}
      <MinimalButton variant="secondary" disabled={busy} onClick={() => setConfirming(true)}>Remove campaign</MinimalButton>
    </>}
  </ChowModal>
}
